import { COUNTRY_AREA_CODES } from "@/Helpers/constants/account.js";

export function hasOnlyUppercase(text) {
    const trimmedInput = text.replace(/[^A-Z']/g, "");

    return trimmedInput === text.toUpperCase().replace(/\s/g, "");
}

export function hasOnlyEmojis(text) {
    const trimmedInputWithoutEmojis = text.replace(
        /[^\p{L}\p{N}\p{P}\p{Z}]/gu,
        ""
    );

    return trimmedInputWithoutEmojis === "";
}

export function hasOnlySpecialCharacters(text) {
    const trimmedInput = text.replace(/[ˆa-zA-Z0-9]/gu, "");
    const trimmedInputWithoutEmojis = trimmedInput.replace(
        /[^\p{L}\p{N}\p{P}\p{Z}]/gu,
        ""
    );

    return trimmedInputWithoutEmojis === text;
}

export function hasForbiddenCharacters(text) {
    const trimmedInput = text.replace(
        /[ˆa-zA-Z0-9- àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ`~!@#$%^&*()_=+'";:?<>,./‘“’”]/gu,
        ""
    );
    const trimmedInputWithoutEmojis = trimmedInput.replace(
        /[^\p{L}\p{N}\p{P}\p{Z}]/gu,
        ""
    );

    return trimmedInputWithoutEmojis !== "";
}

export function setPhoneNumber(phoneNumber) {
    return phoneNumber
        ? phoneNumber
              .replace(COUNTRY_AREA_CODES["DE"], "")
              .replace(COUNTRY_AREA_CODES["AT"], "")
              .replace(COUNTRY_AREA_CODES["CH"], "")
              .replace(COUNTRY_AREA_CODES["LU"], "")
              .replace(COUNTRY_AREA_CODES["NL"], "")
              .replace(COUNTRY_AREA_CODES["BE"], "")
              .replace(COUNTRY_AREA_CODES["ES"], "")
              .replace(COUNTRY_AREA_CODES["FR"], "")
              .replace(COUNTRY_AREA_CODES["DK"], "")
              .replace(/^0+/, "")
        : "";
}

export function setPhoneNumberCountryCode(phoneNumber) {
    if (!phoneNumber) {
        return "DE";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["DE"])) {
        return "DE";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["AT"])) {
        return "AT";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["CH"])) {
        return "CH";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["LU"])) {
        return "LU";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["NL"])) {
        return "NL";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["BE"])) {
        return "BE";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["ES"])) {
        return "ES";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["FR"])) {
        return "FR";
    }
    if (phoneNumber.includes(COUNTRY_AREA_CODES["DK"])) {
        return "DK";
    }
    return "DE";
}

export const mapForText = (value) => {
    return value.map((item) => item.text);
};

export const decodeBase64 = (value) => {
    const base64RegExp =
        /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/;

    if (base64RegExp.test(value)) {
        try {
            return decodeURIComponent(escape(window.atob(value)));
        } catch (error) {
            return value;
        }
    }

    return value;
};

export const formatSnakeCaseToReadable = (value) => {
    if (!value) return "—";
    return value
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
};
